import { useState } from 'react';
import { Box, Checkbox, FormControlLabel, Link, TextField, InputAdornment, IconButton, Alert, Button } from '@mui/material';
import { MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import BASE_API_URL from '../apis/index';

const LoginPage = () => {
  const navigate = useNavigate();
  const [showPswd, setShowPswd] = useState(false);

  const [form, setForm] = useState({
    email: '',
    password: '',
    remember: true,
  });

  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const res = await axios.post(`${BASE_API_URL}/api/auth/login`, {
        email: form.email,
        password: form.password,
      });

      setMessage(res.data.message);
      if (form.remember) {
        localStorage.setItem('authToken', res.data.token);
      }

      setTimeout(() => navigate('/admin/dashboard'), 1000);
    } catch (err) {
      setLoading(false);
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <LoginWrapper>
      <h2 className='text-center txt_color_primary'>Login to SupplyChain</h2>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}

      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          className='w-100'
          label="Enter your Email / User Id"
          name="email"
          value={form.email}
          onChange={handleChange}
          margin="normal"
          required
          autoComplete="email"
        />

        <TextField
          className='w-100'
          label="Password"
          name="password"
          value={form.password}
          onChange={handleChange}
          type={showPswd ? "text" : "password"}
          margin="normal"
          required
          autoComplete="current-password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPswd(prev => !prev)}>
                  {showPswd ? <MdOutlineVisibilityOff /> : <MdOutlineVisibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <div className="d-flex justify-content-between align-items-center my-3">
          <FormControlLabel
            className='p-0 m-0'
            control={
              <Checkbox
                name="remember"
                checked={form.remember}
                onChange={handleChange}
                color="primary"
                className='p-0 m-0'
              />
            }
            label="Remember me"
          />
          <Link href="/forgot-password" className='text-decoration-none'>
            Forgot password?
          </Link>
        </div>

        <Button
          type="submit"
          className='w-100 loginBtn'
          variant="contained"
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </Button>
      </Box>

      <p className="mt-3 text-center">
        Don't have an account?
        <Link href="/register" className="text-decoration-none txt_color_secondary ms-2">
          Register here
        </Link>
      </p>
    </LoginWrapper>
  );
};

export default LoginPage;

const LoginWrapper = styled.div`
  max-width: 500px;
  margin: 100px auto;
  min-height: 62vh;
  input {
    border-radius: 50px;
  }
  label {
    margin: 0px 0px 5px 10px;
  }
  input::placeholder {
    color: var(--grey-color);
  }
  p .para {
    color: var(--secondary-color);
  }
  .loginBtn{
    background: linear-gradient( 155deg, var(--primary-color) 0%, var(--secondary-color) 100% );
    padding: 12px;
    font-weight: 400;
    font-size: 1rem;
    width: 100%;
    border: 1px solid var(--secondary-color);
    border-radius: 5px;
    transition: 0.5s;
    &:hover {
      color: var(--primary-color);
      background: linear-gradient(
        225deg,
        var(--primaryLight-color) 0%,
        var(--secondaryLight-color) 100%
      );
    }
  }
`;

